import { FC } from 'react'
import clsx from 'clsx'
import { useAppSelector } from '../../../hooks/useStore'

type IProps = {
  classes?: string
}
const UserInfo: FC<IProps> = ({ classes }) => {
  const { name, family } = useAppSelector((state) => state.auth.userInfo)
  return (
    <div className={clsx('items-center ml-3 text-xs', `${classes}`)}>
      <span className='text-gray-400'>{`${name ?? ''} ${family ?? ''}`}</span>
      {/* <span className='mr-2 p-1 rounded text-white text-center bg-green-300'>ادمین</span> */}
    </div>
  )
}

export default UserInfo
